// src/utils/tickerValidator.js

// 1. 데이터 로드 (한 곳에서만 로드하여 메모리 절약)
import globalTickers from "../data/global_tickers_min.json"; // 경로 확인 필요

// 2. 검색 및 검증을 위한 Set/Map 생성
// 검색 속도 O(1)을 위해 Set 사용
const tickerSet = new Set(globalTickers.map(item => item.s.toUpperCase()));

// [추가] 초기 로드 시 포맷팅된 리스트를 메모리에 한 번만 생성
const formattedTickers = globalTickers.map(item => ({
    symbol: item.s.toUpperCase(),
    name: (item.n || "NO NAME").toUpperCase(),
    type: item.t,
    exchange: item.e
}));


/** 검색/필터링 로직 (최대 limit개 반환) */
export const getFilteredTickers = (query, limit = 10) => {
    const val = query?.toUpperCase();
    if (!val) return [];

    const starts = [];
    const contains = [];

    // for...of 루프가 대용량 배열 필터링 시 .filter 체이닝보다 빠름
    for (const item of formattedTickers) {
        if (item.symbol.startsWith(val)) {
            starts.push(item);
        } else if (item.symbol.includes(val)) {
            contains.push(item);
        }
        if (starts.length + contains.length >= limit * 2) break; // 과다 탐색 방지
    }

    return [...starts, ...contains].slice(0, limit);
};

/**
 * 로컬 데이터셋에 티커가 있는지 확인 (동기)
 */
export const isValidTickerLocal = (ticker) => {
    if (!ticker) return false;
    return tickerSet.has(ticker.toUpperCase());
};

/**
 * Netlify Function을 통해 유효성 검사 (비동기)
 * 실패 시 null, 성공 시 정제된 티커 반환
 */
export const validateTickerWithAPI = async (ticker) => {
    // return null;
    try {
        const response = await fetch(`/.netlify/functions/checkTicker?ticker=${ticker}`);
        const data = await response.json();
        if (data.valid && data.ticker) {
            return data.ticker; // 예: "005930.KO"
        }
        return null;
    } catch (error) {
        console.error("API Error:", error);
        return null;
    }
};

/**
 * (선택 사항) 자동완성용 전체 데이터 반환이 필요할 때
 */
export const getAllTickers = () => globalTickers;